'use client';
import Typography from '@/components/shared/typography/typography.component';
import { useEffect, useState } from 'react';
import { ILocationDropDown, useTranslation } from '@/hook';
import { ArrowDownSmall } from '../../../../public/Images';
import { StepperRadioButton } from '@/components/sell-car-form';
import styles from './styles.module.scss';
import Image from 'next/image';

interface IStepperLocarionDropdown {
    location: ILocationDropDown;
    buttonClicked: (id: string, value: string) => void;
}

const StepperLocationDropdown = ({
    location,
    buttonClicked,
}: IStepperLocarionDropdown) => {
    const [expand, setExpand] = useState(location.expanded);
    const { IS_RTL } = useTranslation();

    useEffect(() => {
        setExpand(location?.expanded);
    }, [location]);
    return (
        <section
            id={`location_outer_${location.id}`}
            onClick={() => setExpand(!expand)}
            key={location.id}
            className={`${styles.location_dropdown_container} ${
                expand ? styles.expanded : ''
            }`}
        >
            <div className={styles.location_big_area_container}>
                <Typography variant="body2Medium" color={'#344054'}>
                    {IS_RTL ? location.bigAreaAr : location.bigAreaEn}
                </Typography>
                <Image
                    className={`${styles.arrow_img} ${
                        expand ? styles.expanded : ''
                    }`}
                    width={ArrowDownSmall.width}
                    height={ArrowDownSmall.height}
                    src={ArrowDownSmall}
                    alt="expand"
                />
            </div>

            <div
                id={`location_${location.id}`}
                className={`scrollable ${styles.location_small_area_container}`}
            >
                {location.smallArea?.map(smallArea => (
                    <StepperRadioButton
                        id={smallArea?.id}
                        key={smallArea?.nameEn}
                        showAlert={smallArea?.showAlert}
                        selected={smallArea?.selected}
                        icon={''}
                        value={
                            IS_RTL ? smallArea.nameAr : smallArea?.nameEn || ''
                        }
                        buttonClicked={() =>
                            buttonClicked(smallArea?.id, smallArea?.nameEn)
                        }
                        radioGroup={location.bigAreaAr}
                    />
                ))}
            </div>
        </section>
    );
};
export default StepperLocationDropdown;
